// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"247":"9b9df6468896152972bb","777":"6e656b935513dd00381f","880":"bb67a7588a445cf85318"}[chunkId] + ".js";
};